/* eslint-disable no-console */
import { Injectable, inject } from '@angular/core';

import { IGlobalSearchContext } from '../../context/search';
import { SearchContextService } from '../../context/service';
import { SearchIndexLoadEvent } from '../../events';

@Injectable({ providedIn: 'root' })
export class IndexLoaderClientService {
    private searchContextService = inject(SearchContextService);

    private pendingLoad = false;
    private pendingReload = false;
    private searchContext: IGlobalSearchContext;

    constructor() {
        this.searchContext = this.searchContextService;
        if (this.searchContextService) {
            this.searchContextService.contextAvailable.subscribe((searchContext: IGlobalSearchContext) => {
                this.searchContext = searchContext;
                if (this.pendingLoad) {
                    this.loadIndex();
                    this.pendingLoad = false;
                }
                if (this.pendingReload) {
                    this.loadIndex();
                    this.pendingReload = false;
                }
            });
        }
    }

    loadIndex(): void {
        console.info('[GlobalSearch]', '[ProductStub]', '[IndexLoaderClientService]', '[loadIndex]');
        if (this.searchContext && this.searchContext.appContext) {
            this.reloadIndex();
        } else {
            this.pendingLoad = true;
        }
    }

    reloadIndex(): void {
        console.info('[GlobalSearch]', '[ProductStub]', '[IndexLoaderClientService]', '[reloadIndex]');
        dispatchEvent(new CustomEvent(SearchIndexLoadEvent));
    }
}
